import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import "../styles/partnerPortalPopover.css";
import axios from "axios";

const PartnerPortalPopover: React.FC = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    const response = await axios.get(
      `${process.env.REACT_APP_SAML_GATEWAY_URL}/districtCheck?district=${email}`,
      { validateStatus: (status) => true }
    );
    if (response.status !== 200) {
      setError("This domain is not cleared for partner access. Please contact support.");
      return;
    }
    try {
      login(email);
    } catch (error) {
      setError("An error occurred while initiating the login process with the partner organization. Please try again.");
      return;
    }
  };

  return (
    <div className="partner-portal-container">
      <h2 className="partner-portal-title">Sign in to the Partner Portal</h2>
      <div className="partner-portal-content">
        <div className="partner-portal-main">
          <p className="partner-portal-description">
            Authorized institutional and business partners can access restricted
            cross-district analytics and data tools. Enter your partner email to
            proceed.
          </p>

          <form onSubmit={handleSubmit} className="partner-portal-form">
            <div className="field-group">
              <label htmlFor="partner-email" className="field-label">
                Partner Email Address:
              </label>
              <input
                id="partner-email"
                type="email"
                className="select-input"
                placeholder="Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {error && <p className="error-message">{error}</p>}
            </div>

            <button type="submit" className="btn-primary partner-continue-btn">
              <span>Continue</span>
              <span className="arrow-icon">→</span>
            </button>
          </form>

          <div className="partner-portal-footer">
            <div>
              This page is only for registered, approved partners.{" "}
              <p className="attention-bold-text">
                If you are a district user, please return to the main login
                portal.
              </p>
            </div>
            <button
              type="button"
              className="return-link"
              onClick={() => {
                const popover = document.getElementById("partner-popover");
                if (popover) (popover as any).hidePopover();
              }}
            >
              Return to Main Portal
            </button>
          </div>
        </div>

        {/* <div className="partner-portal-sidebar">
          <div className="sidebar-title">Partner Privileges:</div>
          <ul className="sidebar-list">
            <li>View State-wide Enrollment Trends</li>
            <li>Access Grant Compliance Reports</li>
            <li>Cross-District Data Modeling Tools</li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default PartnerPortalPopover;
